import Phaser from "phaser";
import GesturesPlugin from "phaser3-rex-plugins/plugins/gestures-plugin";

import BootScene from "./BootScene";
import MainScene from "./MainScene";

export default class Game {
  constructor(payload) {
    this.payload = payload;
  }

  init() {
    this.createGame();
  }

  createGame() {
    const config = {
      data: this.payload,
      type: Phaser.AUTO,
      width: Game.WIDTH,
      height: Game.HEIGHT,
      backgroundColor: "#FFFFFF",
      parent: this.payload.target.querySelector(".app"),
      pixelArt: false,
      antialias: true,
      scene: [BootScene, MainScene],
      physics: {
        default: "arcade",
        arcade: {
          debug: false,
          gravity: { y: 0 },
        },
      },
      scale: {
        parent: this.payload.target.querySelector(".app"),
        mode: Phaser.Scale.NONE,
        autoCenter: Phaser.Scale.NONE,
        fullscreenTarget: this.payload.target.querySelector(".app"),
        zoom: 1,
      },
      plugins: {
        scene: [
          {
            key: "rexGestures",
            plugin: GesturesPlugin,
            mapping: "rexGestures",
          },
        ],
      },
    };

    Game.targetContext = this.payload.target;
    Game.prefix = this.payload.filenamePrefix;
    Game.suffix = this.payload.filenameSuffix;
    Game.frames = this.payload.totalFrames;
    Game.folderPath = this.payload.folderPath;
    Game.spans = [];
    Game.zoomSteps = [];
    for (let x = 0; x < this.payload.spans.length; x++) {
      Game.spans.push(this.payload.spans[x].span);
      Game.zoomSteps.push(this.payload.spans[x].zoomSteps);
    }
    Game.finalMaxZoom = this.payload.finalMaxZoom ? this.payload.finalMaxZoom : 5;
    Game.autoPlayInterval = this.payload.autoPlayInterval ? this.payload.autoPlayInterval : 100;
    Game.dragThreshold = this.payload.dragThreshold ? this.payload.dragThreshold : 20;

    this.game = new Phaser.Game(config);
  }

  static to3(n) {
    return n < 10 ? "00" + n : n < 100 ? "0" + n : n;
  }
}

Game.WIDTH = 1618;
Game.HEIGHT = 1080;
Game.folderPath = null;
Game.prefix = null;
Game.suffix = null;
Game.frames = null;
Game.spans = null;
Game.zoomSteps = null;
Game.finalMaxZoom = null;
Game.autoPlayInterval = null;
Game.dragThreshold = null;
Game.targetContext = null;
